module.exports = __webpack_public_path__ + "static/media/about6.ffe7b0ab.webp";